import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download, Eye, MoreVertical, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { VerificationSession } from '../../../types/verification';

export interface SessionActionsMenuProps {
  session: VerificationSession;
  onSessionSelect: (session: VerificationSession) => void;
  onSessionDelete?: (sessionId: string) => void;
  onSessionExport?: (sessionId: string) => void;
}

const SessionActionsMenu: React.FC<SessionActionsMenuProps> = ({
  session,
  onSessionSelect,
  onSessionDelete,
  onSessionExport,
}) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={t('common.actions')}
          className="absolute right-1 top-1/2 size-7 -translate-y-1/2"
        >
          <MoreVertical strokeWidth={1.8} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="revy-ui">
        <DropdownMenuItem onSelect={() => onSessionSelect(session)}>
          <Eye strokeWidth={1.8} />
          {t('common.view')}
        </DropdownMenuItem>
        {onSessionExport && (
          <DropdownMenuItem onSelect={() => onSessionExport(session.id)}>
            <Download strokeWidth={1.8} />
            {t('verification.export.excel')}
          </DropdownMenuItem>
        )}
        {onSessionDelete && (
          <DropdownMenuItem
            onSelect={() => onSessionDelete(session.id)}
            className="text-destructive focus:text-destructive"
          >
            <Trash2 strokeWidth={1.8} />
            {t('common.delete')}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SessionActionsMenu;
